<template>
    <div >
        <div class="customProductDetail main" v-if="isPC">
            <div class="breadcrumb">
            <el-breadcrumb separator="<">
                <el-breadcrumb-item class="fontfine" :to="{ path: '/' }">{{ $t('customDetail.Back') }}</el-breadcrumb-item>
                <el-breadcrumb-item><a >{{ $t('customDetail.AddNewDemand') }}</a></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="bg-white content">
            <div class="el-icon-success"></div>
            <div class="successFont1">
                {{ $t('touristCustom.SubmittedSuccessfully')}}
            </div>
            <div class="successFont2">
                {{ $t('touristCustom.tip1')}}
            </div>
            <div class="successFont2">
                {{ $t('touristCustom.tip2')}}
            </div>
            <div class="backButton">
                <el-button @click="backClick">{{ $t('touristCustom.back') }}</el-button>
            </div>
            <el-divider></el-divider>
            <div class="productGroup">
                <div class="title" style="margin-bottom:10px">{{ $t('touristCustom.CustomProduct')}}</div>
                <div class="f-b">
                    <div class="f">
                        <el-image :src="imageUrl" style="width: 60px;height: 60px;" @click="dialogVisible = true" class="pointer"></el-image>
                        <div class="productName">{{ productName }}</div>
                    </div>
                    <div style="width: 240px;">{{ $t('touristCustom.AddedTime') }}:{{ addTime }}</div>
                    <div style="width: 240px;">{{ $t('touristCustom.DemandNo')}}: {{ DemandNo }}</div>
                </div>
            </div>
        </div>
        </div>
        <div class="content_mobile bg-white" v-else>
            <div class="iconBox">
                <i class="el-icon-success"></i>
            </div>
            <div class="successFont1">
                {{ $t('touristCustom.SubmittedSuccessfully')}}
            </div>
            <div class="title">{{ $t('touristCustom.CustomProduct')}}</div>
            <div class="product f">
                <el-image :src="imageUrl" @click="dialogVisible = true" class="image"></el-image>
                <div class="productName">{{ productName }}</div>
            </div>
            <div class="f-b info">
                <div>{{ $t('touristCustom.DemandNo')}}</div>
                <div>{{ DemandNo }}</div>
            </div>
            <div class="divider"></div>
            <div class="f-b info">
                <div>{{ $t('touristCustom.AddedTime') }}</div>
                <div>{{ addTime }}</div>
            </div>
            <div class="divider"></div>
            <div class="bottomBtn bg-white f-c-c">
                <el-button type="primary" @click="backClick">{{ $t('touristCustom.Home') }}</el-button>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="1200px">
            <img width="100%" :src="imageUrl">
        </el-dialog>
    </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  data() {
    return {
      productName: undefined,
      DemandNo: undefined,
      addTime: undefined,
      email: undefined,
      imageUrl: '',
      dialogVisible: false
    }
  },
  created() {
    const { email, productName, DemandNo, addTime, imageUrl } = this.$store.state.commodity.touristAddCustom
    this.email = email
    this.productName = productName
    this.DemandNo = DemandNo
    this.addTime = dayjs(addTime).format('YYYY/MM/DD HH:mm')
    this.imageUrl = imageUrl
  },
  methods: {
    backClick() {
      if (+this.$route.query.isList === 1) {
        this.$router.push('/commodity/CustomProduct/list')
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.customProductDetail {
    // padding-top: 10px;
    min-height: 100%;
    padding-bottom: 100px;
    .breadcrumb {
        padding: 20px 0;
    }
    .content {
        text-align: center;
        padding: 40px;
        .el-icon-success {
            color: #99C41C;
            font-size: 70px;
            margin-bottom: 20px;
        }
        .successFont1 {
            font-size: 24px;
            font-weight: 400;
            margin-bottom: 20px;
        }
        .successFont2 {
            font-size: 16px;
            font-weight: 400;
            color: #8B93A3;
            margin-bottom: 10px;
        }
        .backButton {
            margin: 30px 0;
        }
        .productGroup {
            width: 800px;
            margin: 0 auto;
            text-align: left;
            .title {
                font-size: 16px;
                font-weight: 600;
                color: #000000;
            }
            .productName {
                color: #747A87;
                width: 180px;
                margin-left: 18px;
            }

        }
    }

}
.content_mobile {
        min-height: 100vh;
        padding: 1rem .3rem 0;
        .iconBox {
            text-align: center;
            .el-icon-success {
                color: #99C41C;
                font-size: 1rem;
                margin-bottom: .3rem;
            }
        }
        .successFont1 {
            font-size: .35rem;
            font-weight: 600;
            margin-bottom: 1rem;
            text-align: center;
        }
        .title {
            font-size: .3rem;
            font-weight: 600;
            // padding: 0 .3rem;
        }
        .product {
            padding: .3rem 0;
            /deep/.el-image {
                width: 1.4rem;
                height: 1.4rem;
                margin-right: .2rem;
            }
        }
        .info {
            padding: .3rem 0;
            font-size: .3rem;
        }
        .divider {
            width: 100%;
            height: 1px;
            background-color: #DEDEDE;
            transform: scaleY(0.5);
        }
        .bottomBtn {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 1rem;
            >button {
                width: 60%;
            }
        }
    }
</style>
